import {
  ACADEMICS_TYPE_ID,
  AGENT_TYPE_ID,
  AOS_TYPE_ID,
  ARTIST_TYPE_ID,
  CASTING_TYPE_ID,
  JOURNALIST_TYPE_ID,
  TP,
} from '../../../constants/consts';

export const GET_STORED_REGISTRATIONS = 'app/Registration/GET_STORED_REGISTRATIONS';
export const CREATE_REGISTRATION = 'app/Registration/CREATE_REGISTRATION';
export const UPDATE_REGISTRATION = 'app/Registration/UPDATE_REGISTRATION';
export const INIT_REGISTRATION = 'app/Registration/INIT_REGISTRATION';
export const SET_ACTIVE_REGISTRATION = 'app/Registration/SET_ACTIVE_REGISTRATION';
export const SEARCH_AGENCIES = 'app/Registration/SEARCH_AGENCIES';
export const CREATE_PROFILE = 'app/Registration/CREATE_PROFILE';
export const CREATE_AOS_PROFILE = 'app/Registration/CREATE_AOS_PROFILE';
export const CREATE_AGENCY_PROFILE = 'app/Registration/CREATE_AGENCY_PROFILE';
export const CREATE_ARTIST_PROFILE = 'app/Registration/CREATE_ARTIST_PROFILE';
export const UPDATE_PROFILE = 'app/Registration/UPDATE_PROFILE';
export const PROFILE_ACCESSES = 'app/Registration/PROFILE_ACCESSES';
export const CREATE_COMPANY = 'app/Registration/CREATE_COMPANY';
export const CREATE_AGENCY = 'app/Registration/CREATE_AGENCY';
export const SET_REGISTRATION_PROFILE = 'app/Registration/SET_REGISTRATION_PROFILE';
export const SET_REGISTRATION_TOKEN = 'app/Registration/SET_REGISTRATION_TOKEN';
export const INIT_REGISTRATION_CONTACT = 'app/Registration/INIT_REGISTRATION_CONTACT';
export const CHOOSE_PROFILE_TYPE = 'app/Registration/CHOOSE_PROFILE_TYPE';
export const UPDATE_USER_INFO = 'app/Registration/UPDATE_USER_INFO';
export const CREATE_GIFT_ACCOUNT = 'app/Registration/CREATE_GIFT_ACCOUNT';
export const UPDATE_GIFT_PROFILE = 'app/Registration/UPDATE_GIFT_PROFILE';

export const REGISTRATION_STEPS = {
  createAccount: '1.1',
  updateUserInfo: '1.1.1',
  createFreeProfile: '1.2',
  createGiftAccount: '1.3',
  chooseProfileType: '2',
  updateGiftProfile: '2.1.1',
  checkProfile: '3.1',
  subscriptionPlan: '3.1.1',
  setUpProfile: '3.2',
  freeProfileDetails: '3.3',
  digitalPresence: '3.4',
  addingPerformances: '3.4.1',
  payment: '4',
  congratulation: '5',
  congratulationFromPrPro: '5.1',
  finished: '6',
};

export const FORM_TYPE = {
  REGISTER: 'register',
  CONTACT: 'contact',
};

export const REG_HBSPT_FORM_DATA = (step, type, env) => {
  switch (step) {
    case REGISTRATION_STEPS.createGiftAccount:
    case REGISTRATION_STEPS.createAccount: {
      const withoutType = {
        formId: env === 'production' ? 'b428fa3a-d3ad-43c4-ad01-d84bd2401eca' : '33ed4922-d60c-4da3-a8ec-dcb54e0b43ec',
        step: '1',
      }; // Step 1 (New Registration process without type)
      const withType = {
        formId: env === 'production' ? 'f31c7bde-ab97-4c50-b662-d0ee69b97228' : '3cbe434f-dc76-4f8b-8eaf-099bd9f16478',
        step: '1',
      }; // Step 1 (New Registration process with type)
      return type ? withType : withoutType;
    }

    case REGISTRATION_STEPS.updateUserInfo:
      return {
        formId: env === 'production' ? '18ab3bd2-fa6b-4ad7-81af-f02e8346164d' : '6521fa71-96e8-4db6-bb7c-59d333e3277b',
        step: '1.1',
      }; // Step 1.1 (Update user information)

    case REGISTRATION_STEPS.createFreeProfile: {
      const proProfileInfo = {
        [AGENT_TYPE_ID]:
          env === 'production' ? 'a4cf7fbc-6c89-4516-be00-dc2f9fc964a1' : '2db742f8-d296-4d3d-b125-b0730269a85b',
        [AOS_TYPE_ID]:
          env === 'production' ? '65fa35d4-f135-46c6-af17-5e9856152731' : '92d946d7-2515-497b-811d-9bcf9b150d01',
        [ACADEMICS_TYPE_ID]:
          env === 'production' ? '7f7e32c5-c56a-43b6-81fa-e83b8471833e' : '2dde5fb3-4f23-4040-a0dd-ff1c7ee67f8a',
        [JOURNALIST_TYPE_ID]:
          env === 'production' ? 'edc8d820-c7bf-4d35-b40f-385712ba8fa0' : '0baa1e5d-1739-445b-8fd0-325386af59c6',
        [CASTING_TYPE_ID]:
          env === 'production' ? '67d07106-84cb-4595-9243-83b49cabacdb' : 'd781f5b9-4e07-4cf0-833a-5ef4590ac854',
      };
      return { formId: proProfileInfo[type], step: '1' }; // Step 1 (Create Contact us Profile)
    }

    case REGISTRATION_STEPS.chooseProfileType:
      return {
        formId: env === 'production' ? '327f5eea-45a0-4270-ab7d-b865f06ee438' : 'cdbaf711-a3dc-46f5-a51f-a311749197eb',
        step: '2',
      }; // Step 2 (Select Profile Type)

    case REGISTRATION_STEPS.subscriptionPlan: {
      const subscriptionPlanInfo = {
        [AGENT_TYPE_ID]:
          env === 'production' ? '1fc81472-33b3-4091-b15e-ea1da3eec14e' : '5ce3b024-8f7d-4ba5-84b7-3c9fd80a424e',
        [AOS_TYPE_ID]:
          env === 'production' ? '1354de99-0d02-482a-a90c-1d8a17cfd943' : 'fbf4c68a-0d65-448f-a524-b2260cfa9437',
        [ARTIST_TYPE_ID]:
          env === 'production' ? '509c54a7-2667-47c8-8608-fbeaca8fefe0' : '8984f87a-88be-4fd1-89c3-3966e1ef602c',
      };
      return { formId: subscriptionPlanInfo[type], step: '4' }; // Step 4 (Choose subscription plan)
    }

    case REGISTRATION_STEPS.checkProfile: {
      const checkProfileInfo = {
        [AGENT_TYPE_ID]: {
          formId:
            env === 'production' ? '9509fdfe-73a7-4652-a21e-b8b3f8c7c4d9' : '5b7e44c5-c060-470b-8d41-3b3ca7c8ea8d',
          step: '3.1',
        }, // Step 3.1 (Claim Agency Page)
        [ARTIST_TYPE_ID]: {
          formId:
            env === 'production' ? '68f9736e-72c3-41c3-b0fd-66ec8ddda95b' : '8da74198-88c5-4154-b312-2425ff09f15f',
          step: '6.1',
        }, // Step 6.1 (Claim Artist Profile)
        [AOS_TYPE_ID]: {
          formId:
            env === 'production' ? '30fc0122-6e1f-40d3-948c-b9d5d36b70a3' : '1d0a9cf6-0539-4b2c-a21d-2de955befca2',
          step: '3.1',
        }, // Step 3.1 (Claim Arts Organisation Page)
      };
      return checkProfileInfo[type];
    }
    case REGISTRATION_STEPS.updateGiftProfile:
    case REGISTRATION_STEPS.setUpProfile: {
      const setUpProfileInfo = {
        [AGENT_TYPE_ID]: {
          formId:
            env === 'production' ? '44149574-e540-4566-aeea-38766bae7217' : 'fb543935-9354-49f0-9531-a4fbf94eff79',
          step: '3.2',
        }, // Step 3.2 (Setup New Agency)
        [AOS_TYPE_ID]: {
          formId:
            env === 'production' ? '6c32df22-e205-4d30-a387-672add774682' : 'f55f8832-dd84-42bf-9b67-13e2a53f38b4',
          step: '3.2',
        }, // Step 3.2 (Setup New Agency)
        [ARTIST_TYPE_ID]: {
          formId:
            env === 'production' ? 'ea0c8216-a9f6-4e68-ad25-9b2bd1cb045e' : 'a6e9204b-cf84-45cd-a4b6-d8614988c385',
          step: '6.2',
        }, // Step 6.2 (Setup New Profile)
      };
      return setUpProfileInfo[type];
    }

    case REGISTRATION_STEPS.freeProfileDetails: {
      const profileDetailsInfo = {
        [AGENT_TYPE_ID]:
          env === 'production' ? 'ff7358b7-d465-4fa1-acd5-f9981aeefc63' : '214fe6ac-0d1b-451a-8bdb-053d201ee8cf',
        [AOS_TYPE_ID]:
          env === 'production' ? 'e17f8480-a58f-4c9f-b052-f70ee785d279' : '388a2392-78d0-47cf-9cec-e7be79218cf9',
        [ACADEMICS_TYPE_ID]:
          env === 'production' ? 'bd9f9724-8f75-49a8-847e-9a61a558a492' : '199c1e35-96b6-4309-bd79-c013a5ca0738',
        [JOURNALIST_TYPE_ID]:
          env === 'production' ? 'e4706280-1d69-45ad-aa23-4bf1903457e0' : '97eba67a-c7d6-41a2-a836-bfc893b28104',
        [CASTING_TYPE_ID]:
          env === 'production' ? 'f3fe8397-f388-4ed2-a327-0dcd93c2bd5b' : 'e5c3567d-d9f0-44af-9e2a-bb71224cafcc',
      };
      return { formId: profileDetailsInfo[type], step: '2' }; // Step 2 (Details Contact us Profiles)
    }

    case REGISTRATION_STEPS.digitalPresence: {
      const subscriptionPlanInfo = {
        [ARTIST_TYPE_ID]:
          env === 'production' ? '8e32b66d-9b88-424f-8362-b89637bdef5f' : '68b915a3-a32b-415b-aec5-281543e24f9c',
      };
      return { formId: subscriptionPlanInfo[type], step: '3.4' };
    }

    case REGISTRATION_STEPS.congratulation: {
      const congratulationInfo = {
        [AGENT_TYPE_ID]: {
          formId:
            env === 'production' ? '10c712e7-fa2f-4c22-a2dc-7523b347a60a' : '0e4eb2d4-6c0b-418f-9b77-58f7e48c14f6',
          step: '7',
        }, // Step 7 (Contact us or view page)
        [AOS_TYPE_ID]: {
          formId:
            env === 'production' ? '4bef3b5e-a11a-4693-bb13-68492fbe4c47' : 'e11f5eb9-e4a9-4394-9b6c-1bbf1161975d',
          step: '7',
        }, // Step 7 (Confirmation screen)
        [ARTIST_TYPE_ID]: {
          formId:
            env === 'production' ? '33796ee7-e605-4d49-9e80-9fbc7f118bd6' : 'e8edc7c5-1476-4b75-8e11-d1c9d17cdc9c',
          step: '8',
        }, // Step 8 (Viewed Artist Profile)
      };
      return congratulationInfo[type];
    }

    default:
      return null;
  }
};
export const NAME_SECOND_STEP = type => {
  switch (Number(type)) {
    case AOS_TYPE_ID:
      return `${TP}.STEPPER_SHARE_COMPANY`;
    case AGENT_TYPE_ID:
      return `${TP}.STEPPER_SHARE_AGENCY`;

    default:
      return `${TP}.STEPPER_SHARE_INFO`;
  }
};
export const AGENCY_ROSTER_PRO = 'Agency Roster PRO';
export const PUBLIC_RELATIONS_PRO = 'Public Relations PRO';
export const CUSTOM_SUBSCRIPTION_NAME = {
  [AGENT_TYPE_ID]: 'Agency Roster PRO',
  [AOS_TYPE_ID]: 'Public Relations PRO',
  [ACADEMICS_TYPE_ID]: 'Academics PRO',
  [JOURNALIST_TYPE_ID]: 'Journalist and media PRO',
  [CASTING_TYPE_ID]: 'Casting tool PRO',
};

export const MEETING_LINK = 'https://meetings.hubspot.com/operabase-website-update/meet-with-operabase';

export const getFirstStep = type =>
  Number(type) === ARTIST_TYPE_ID ? REGISTRATION_STEPS.setUpProfile : REGISTRATION_STEPS.checkProfile;

export const checkStep = (as, userInfo = false) => {
  if (userInfo) {
    return REGISTRATION_STEPS.updateUserInfo;
  }
  return as ? getFirstStep(as) : REGISTRATION_STEPS.chooseProfileType;
};

export const NAME_VALIDATION = /^[A-Za-z'\-\u00C0-\u017F ]+$/;

export const proProfileTypesOptions = {
  [AGENT_TYPE_ID]: {
    value: AGENT_TYPE_ID,
    label: `${TP}.m_ACCOUNT_TYPES_AGENT`,
  },
  [ACADEMICS_TYPE_ID]: {
    value: ACADEMICS_TYPE_ID,
    label: `${TP}.m_ACCOUNT_TYPES_ACADEMICS`,
  },
  [JOURNALIST_TYPE_ID]: {
    value: JOURNALIST_TYPE_ID,
    label: `${TP}.m_ACCOUNT_TYPES_JOURNALIST`,
  },
  [CASTING_TYPE_ID]: {
    value: CASTING_TYPE_ID,
    label: `${TP}.m_CASTING`,
  },
};

export const profileTypesOptions = {
  [ARTIST_TYPE_ID]: {
    value: ARTIST_TYPE_ID,
    label: 'operabase.general.m_ACCOUNT_TYPES_ARTIST',
  },
  [AOS_TYPE_ID]: {
    value: AOS_TYPE_ID,
    label: 'operabase.general.m_ACCOUNT_TYPES_AOS',
  },
  [AGENT_TYPE_ID]: {
    value: AGENT_TYPE_ID,
    label: 'operabase.general.m_ACCOUNT_TYPES_AGENT',
  },
};

export const VWO_GOAL_CONVERSION_IDS = () => {
  const env = process.env.APP_ENV;

  return {
    [REGISTRATION_STEPS.createAccount]: env === 'production' ? 32 : 8,
    [REGISTRATION_STEPS.createFreeProfile]: env === 'production' ? 32 : 8,
  };
};

export const VWO_AB_TEST_GOAL_CONVERSION_IDS = () => {
  const env = process.env.APP_ENV;

  return {
    [REGISTRATION_STEPS.createAccount]: env === 'production' ? 201 : 201,
  };
};

export const GIFT_TOKEN_TYPES = {
  USER: 'user',
  GIFT: 'gift',
  ADMIN: 'admin',
};
